exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sidebar-above-notifications{z-index:1500!important}.sidebar-above-notifications~[role=none],[role=none]:has(+[data-atb-id=side-menu-sheet-id].sidebar-above-notifications){z-index:1499!important}.sidebar-navbar-spacer{height:calc(50px + var(--email-header-offset, 0px))}.portal-sidebar-content{transition:width .2s ease}.portal-sidebar-content .portal-sidebar-nav-btn svg{width:24px;height:24px;flex-shrink:0;flex-grow:0;transition:none}", ""]);

// exports
